import { useCallback } from 'react';
import { useUpdateEmissorContractAddressMutation, } from '../services/contractAddressesApi';
export function useEmissorUpdateContractAddress() {
    const [trigger, state] = useUpdateEmissorContractAddressMutation();
    const updateAddress = useCallback(({ contractId, addressId, body }) => trigger({ contractId, addressId, body }).unwrap(), [trigger]);
    return { updateAddress, isUpdating: state.isLoading };
}
